import React from 'react';

const OfficeBearers = () => {
  const members = [
    { name: "Vinod Kumar", designation: "President" },
    { name: "Suman Pal", designation: "Secretary" },
    { name: "Santosh Kumar Pal", designation: "Treasurer" },
    { name: "Neeta Verma", designation: "Board Member" },
    { name: "Harish Kumar Pal", designation: "Board Member" }
  ];

  return (
    <div className="card h-100 border-0 shadow-sm org-card position-relative">
      {/* Top blue gradient line */}
      <div className="card-top-line position-absolute top-0 w-100"></div>
      
      <div className="card-body p-4 p-xl-5 mt-2">
        <h4 className="org-title mb-4 pb-3 border-bottom">Office Bearers</h4>
        
        <ul className="list-group list-group-flush">
          {members.map((member, index) => (
            <li 
              key={index} 
              className="list-group-item d-flex justify-content-between align-items-center px-0 py-3 bg-transparent"
              style={{ borderBottom: '1px solid #f1f5f9' }} // Light border for separation
            >
              <div className="d-flex align-items-center gap-3">
                {/* Premium Avatar Icon */}
                <div 
                  className="rounded-circle d-flex justify-content-center align-items-center shadow-sm" 
                  style={{ width: '40px', height: '40px', backgroundColor: '#e0f2fe', color: '#0369a1', fontWeight: 'bold', fontSize: '1.1rem' }}
                >
                  {member.name.charAt(0)}
                </div>
                <span className="org-value mb-0" style={{ fontSize: '1rem' }}>{member.name}</span>
              </div>
              
              {/* Modern Badge styling */}
              <span 
                className="badge rounded-pill px-3 py-2 fw-semibold" 
                style={{ backgroundColor: '#f8fafc', color: '#475569', border: '1px solid #e2e8f0', letterSpacing: '0.5px' }}
              >
                {member.designation}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OfficeBearers;